import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const fetchVariantsStarted = createAction(
  'vehicleLink/fetchVariantsStarted'
);
export const fetchVariantsSucceeded = createAction(
  'vehicleLink/fetchVariantsSucceeded'
);
export const fetchVariantsFailed = createAction(
  'vehicleLink/fetchVariantsFailed'
);
export const setVariants = createAction('vehicleLink/setVariants');

export const fetchVariants = (params) => (dispatch, getState) => {
  const cacheKeyName = `${params.code}_${params.makeCode}_${params.familyCode}_${params.bodyStyleCode}_${params.yearCode}`;
  const existingVariants = getState().vehicleLink.variants[cacheKeyName];

  if (existingVariants) {
    return existingVariants;
  }

  dispatch(fetchVariantsStarted());

  return EcomEngineAPI.vehicleLink
    .variants(params)
    .then((variants) => {
      dispatch(fetchVariantsSucceeded());
      dispatch(setVariants({ cacheKeyName, variants }));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchVariantsFailed(error.message));
    });
};
